import { PropsWithChildren } from 'react';

import { TVStyleProps } from '../../style-system';

import { gridColStyles, gridStyles, gridSubgridStyles } from './grid.styles';

type GridProps = PropsWithChildren<TVStyleProps<typeof gridStyles>>;

const Grid = ({ children, gap = 6, dense = true, contentType = 'dashboard', ...rest }: GridProps) => {
    return <div className={gridStyles({ ...rest, gap, dense, contentType })}>{children}</div>;
};

type SubGridProps = PropsWithChildren<TVStyleProps<typeof gridSubgridStyles>>;

const SubGrid = ({ children, ...rest }: SubGridProps) => {
    return <div className={gridSubgridStyles(rest)}>{children}</div>;
};

type ColProps = PropsWithChildren<TVStyleProps<typeof gridColStyles>>;

const Col = ({ children, ...rest }: ColProps) => {
    return <div className={gridColStyles(rest)}>{children}</div>;
};

Grid.Col = Col;
Grid.SubGrid = SubGrid;

export type { ColProps, GridProps, SubGridProps };
export { Grid };
